<template>
  <div id="subpage" v-loading="loading">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>首页</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>站点设置</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <span class="title">站点设置</span>
      </div>
      <div class="xcx-content">
        <el-form
          ref="form_data"
          :model="form_data"
          :rules="rules"
          label-width="160px"
          style="width: 80%"
        >
          <el-tabs v-model="activeName">
            <el-tab-pane label="基本信息(中文)" name="first">
              <el-form-item label="站点标题：" prop="zh_title">
                <el-input v-model="form_data.zh_title" placeholder="请输入站点标题"></el-input>
              </el-form-item>
              <el-form-item label="分享关键词：" prop="zh_keywords">
                <el-input v-model="form_data.zh_keywords" placeholder="请输入分享关键词"></el-input>
              </el-form-item>
              <el-form-item label="分享描述：" prop="zh_description">
                <el-input v-model="form_data.zh_description" type="textarea" placeholder="请输入分享描述"></el-input>
              </el-form-item>
              <el-form-item label="联系电话：" prop="phone">
                <el-input v-model="form_data.phone" placeholder="请输入联系电话"></el-input>
              </el-form-item>
              <!-- <el-form-item label="胸痛热线：" prop="mobile">
                <el-input v-model="form_data.mobile" placeholder="请输入胸痛热线"></el-input>
              </el-form-item> -->
              <el-form-item label="德达名称：" prop="zh_dd_title">
                <el-input v-model="form_data.zh_dd_title" placeholder="请输入德达名称"></el-input>
              </el-form-item>
              <el-form-item label="德达地址：" prop="zh_dd_address">
                <el-input v-model="form_data.zh_dd_address" placeholder="请输入德达地址"></el-input>
              </el-form-item>
              <el-form-item label="德达邮箱：" prop="dd_email">
                <el-input v-model="form_data.dd_email" placeholder="请输入德达邮箱"></el-input>
              </el-form-item>

              <el-form-item label="德西名称：" prop="zh_dx_title">
                <el-input v-model="form_data.zh_dx_title" placeholder="请输入德西名称"></el-input>
              </el-form-item>
              <el-form-item label="德西地址：" prop="zh_dx_address">
                <el-input v-model="form_data.zh_dx_address" placeholder="请输入德西地址"></el-input>
              </el-form-item>
              <el-form-item label="德西邮箱：" prop="dx_email">
                <el-input v-model="form_data.dx_email" placeholder="请输入德西邮箱"></el-input>
              </el-form-item>
              <el-form-item label="公共交通：" prop="zh_traffic">
                <el-input v-model="form_data.zh_traffic" type="textarea" placeholder="请输入公共交通"></el-input>
              </el-form-item>
              <el-form-item label="驾车路线：" prop="zh_bus">
                <el-input v-model="form_data.zh_bus" type="textarea" placeholder="请输入驾车路线"></el-input>
              </el-form-item>
              <el-form-item label="ICP备案：" prop="icp">
                <el-input v-model="form_data.icp" placeholder="请输入ICP备案"></el-input>
              </el-form-item>
              <el-form-item label="版权信息：" prop="copyright">
                <el-input v-model="form_data.copyright" type="textarea" placeholder="请输入分享描述"></el-input>
              </el-form-item>
              <el-form-item label="服务号名称：" prop="zh_qrcode1_title">
                <el-input v-model="form_data.zh_qrcode1_title" placeholder="请输入服务号名称"></el-input>
              </el-form-item>
              <el-form-item label="服务号二维码：" prop="qrcode1" class="txt_left kind_img">
                <upload-one w="150px" h="100px" v-model="form_data.qrcode1"></upload-one>
                <div style="font-size: 12px; color: #606266">为1:1比例图片 （不小于140 x 140px）</div>
              </el-form-item>

              <el-form-item label="视频号名称：" prop="zh_qrcode2_title">
                <el-input v-model="form_data.zh_qrcode2_title" placeholder="请输入视频号名称"></el-input>
              </el-form-item>

              <el-form-item label="视频号二维码：" prop="qrcode2" class="txt_left kind_img">
                <upload-one w="150px" h="100px" v-model="form_data.qrcode2"></upload-one>
                <div style="font-size: 12px; color: #606266">为1:1比例图片 （不小于140 x 140px）</div>
              </el-form-item>

              <el-form-item label="小助手名称：" prop="zh_qrcode3_title">
                <el-input v-model="form_data.zh_qrcode3_title" placeholder="请输入小助手名称"></el-input>
              </el-form-item>
              <el-form-item label="小助手二维码：" prop="qrcode3" class="txt_left kind_img">
                <upload-one w="150px" h="100px" v-model="form_data.qrcode3"></upload-one>
                <div style="font-size: 12px; color: #606266">为1:1比例图片 （不小于140 x 140px）</div>
              </el-form-item>
              <el-form-item label="新浪微博名称：" prop="zh_qrcode4_title">
                <el-input v-model="form_data.zh_qrcode4_title" placeholder="请输入新浪微博名称"></el-input>
              </el-form-item>
              <el-form-item label="新浪微博二维码：" prop="qrcode4" class="txt_left kind_img">
                <upload-one w="150px" h="100px" v-model="form_data.qrcode4"></upload-one>
                <div style="font-size: 12px; color: #606266">为1:1比例图片 （不小于140 x 140px）</div>
              </el-form-item>
              <el-form-item label="微商城名称：" prop="zh_qrcode5_title">
                <el-input v-model="form_data.zh_qrcode5_title" placeholder="请输入微商城名称"></el-input>
              </el-form-item>
              <el-form-item label="微商城二维码" prop="qrcode5" class="txt_left kind_img">
                <upload-one w="150px" h="100px" v-model="form_data.qrcode5"></upload-one>
                <div style="font-size: 12px; color: #606266">为1:1比例图片 （不小于140 x 140px）</div>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="基本信息(英文)" name="second">
              <el-form-item label="站点标题：" prop="en_title">
                <el-input v-model="form_data.en_title" placeholder="请输入站点标题"></el-input>
              </el-form-item>
              <el-form-item label="分享关键词：" prop="en_keywords">
                <el-input v-model="form_data.en_keywords" placeholder="请输入分享关键词"></el-input>
              </el-form-item>
              <el-form-item label="分享描述：" prop="en_description">
                <el-input v-model="form_data.en_description" type="textarea" placeholder="请输入分享描述"></el-input>
              </el-form-item>
              <el-form-item label="德达名称：" prop="en_dd_title">
                <el-input v-model="form_data.en_dd_title" placeholder="请输入德达名称"></el-input>
              </el-form-item>
              <el-form-item label="德达地址：" prop="en_dd_address">
                <el-input v-model="form_data.en_dd_address" placeholder="请输入德达地址"></el-input>
              </el-form-item>
              <el-form-item label="德西名称：" prop="en_dx_title">
                <el-input v-model="form_data.en_dx_title" placeholder="请输入德西名称"></el-input>
              </el-form-item>
              <el-form-item label="德西地址：" prop="en_dx_address">
                <el-input v-model="form_data.en_dx_address" placeholder="请输入德西地址"></el-input>
              </el-form-item>
              <el-form-item label="公共交通：" prop="en_traffic">
                <el-input v-model="form_data.en_traffic" type="textarea" placeholder="请输入公共交通"></el-input>
              </el-form-item>
              <el-form-item label="驾车路线：" prop="en_bus">
                <el-input v-model="form_data.en_bus" type="textarea" placeholder="请输入驾车路线"></el-input>
              </el-form-item>
              <el-form-item label="版权信息：" prop="en_copyright">
                <el-input v-model="form_data.en_copyright" placeholder="请输入版权信息"></el-input>
              </el-form-item>
              <el-form-item label="服务号名称：" prop="en_qrcode1_title">
                <el-input v-model="form_data.en_qrcode1_title" placeholder="请输入服务号名称"></el-input>
              </el-form-item>
              <el-form-item label="视频号名称：" prop="en_qrcode2_title">
                <el-input v-model="form_data.en_qrcode2_title" placeholder="请输入视频号名称"></el-input>
              </el-form-item>
              <el-form-item label="小助手名称：" prop="en_qrcode3_title">
                <el-input v-model="form_data.en_qrcode3_title" placeholder="请输入小助手名称"></el-input>
              </el-form-item>
              <el-form-item label="新浪微博名称：" prop="en_qrcode4_title">
                <el-input v-model="form_data.en_qrcode4_title" placeholder="请输入新浪微博名称"></el-input>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="基本信息(日文)" name="third">
              <el-form-item label="站点标题：" prop="ja_title">
                <el-input v-model="form_data.ja_title" placeholder="请输入站点标题"></el-input>
              </el-form-item>
              <el-form-item label="分享关键词：" prop="ja_keywords">
                <el-input v-model="form_data.ja_keywords" placeholder="请输入分享关键词"></el-input>
              </el-form-item>
              <el-form-item label="分享描述：" prop="ja_description">
                <el-input v-model="form_data.ja_description" type="textarea" placeholder="请输入分享描述"></el-input>
              </el-form-item>
              <el-form-item label="德达名称：" prop="ja_dd_title">
                <el-input v-model="form_data.ja_dd_title" placeholder="请输入德达名称"></el-input>
              </el-form-item>
              <el-form-item label="德达地址：" prop="ja_dd_address">
                <el-input v-model="form_data.ja_dd_address" placeholder="请输入德达地址"></el-input>
              </el-form-item>
              <el-form-item label="德西名称：" prop="ja_dx_title">
                <el-input v-model="form_data.ja_dx_title" placeholder="请输入德西名称"></el-input>
              </el-form-item>
              <el-form-item label="德西地址：" prop="ja_dx_address">
                <el-input v-model="form_data.ja_dx_address" placeholder="请输入德西地址"></el-input>
              </el-form-item>
               <el-form-item label="公共交通：" prop="ja_traffic">
                <el-input v-model="form_data.ja_traffic" type="textarea" placeholder="请输入公共交通"></el-input>
              </el-form-item>
              <el-form-item label="驾车路线：" prop="ja_bus">
                <el-input v-model="form_data.ja_bus" type="textarea" placeholder="请输入驾车路线"></el-input>
              </el-form-item>
              <el-form-item label="版权信息：" prop="ja_copyright">
                <el-input v-model="form_data.ja_copyright" placeholder="请输入版权信息"></el-input>
              </el-form-item>
              <el-form-item label="服务号名称：" prop="ja_qrcode1_title">
                <el-input v-model="form_data.ja_qrcode1_title" placeholder="请输入服务号名称"></el-input>
              </el-form-item>
              <el-form-item label="视频号名称：" prop="ja_qrcode2_title">
                <el-input v-model="form_data.ja_qrcode2_title" placeholder="请输入视频号名称"></el-input>
              </el-form-item>
              <el-form-item label="小助手名称：" prop="ja_qrcode3_title">
                <el-input v-model="form_data.ja_qrcode3_title" placeholder="请输入小助手名称"></el-input>
              </el-form-item>
              <el-form-item label="新浪微博名称：" prop="ja_qrcode4_title">
                <el-input v-model="form_data.ja_qrcode4_title" placeholder="请输入新浪微博名称"></el-input>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="基本信息(韩文)" name="fourth">
              <el-form-item label="站点标题：" prop="ko_title">
                <el-input v-model="form_data.ko_title" placeholder="请输入站点标题"></el-input>
              </el-form-item>
              <el-form-item label="分享关键词：" prop="ko_keywords">
                <el-input v-model="form_data.ko_keywords" placeholder="请输入分享关键词"></el-input>
              </el-form-item>
              <el-form-item label="分享描述：" prop="ko_description">
                <el-input v-model="form_data.ko_description" type="textarea" placeholder="请输入分享描述"></el-input>
              </el-form-item>
              <el-form-item label="德达名称：" prop="ko_dd_title">
                <el-input v-model="form_data.ko_dd_title" placeholder="请输入德达名称"></el-input>
              </el-form-item>
              <el-form-item label="德达地址：" prop="ko_dd_address">
                <el-input v-model="form_data.ko_dd_address" placeholder="请输入德达地址"></el-input>
              </el-form-item>
              <el-form-item label="德西名称：" prop="ko_dx_title">
                <el-input v-model="form_data.ko_dx_title" placeholder="请输入德西名称"></el-input>
              </el-form-item>
              <el-form-item label="德西地址：" prop="ko_dx_address">
                <el-input v-model="form_data.ko_dx_address" placeholder="请输入德西地址"></el-input>
              </el-form-item>
              <el-form-item label="公共交通：" prop="ko_traffic">
                <el-input v-model="form_data.ko_traffic" type="textarea" placeholder="请输入公共交通"></el-input>
              </el-form-item>
              <el-form-item label="驾车路线：" prop="ko_bus">
                <el-input v-model="form_data.ko_bus" type="textarea" placeholder="请输入驾车路线"></el-input>
              </el-form-item>
              <el-form-item label="版权信息：" prop="ko_copyright">
                <el-input v-model="form_data.ko_copyright" placeholder="请输入版权信息"></el-input>
              </el-form-item>
              <el-form-item label="服务号名称：" prop="ko_qrcode1_title">
                <el-input v-model="form_data.ko_qrcode1_title" placeholder="请输入服务号名称"></el-input>
              </el-form-item>
              <el-form-item label="视频号名称：" prop="ko_qrcode2_title">
                <el-input v-model="form_data.ko_qrcode2_title" placeholder="请输入视频号名称"></el-input>
              </el-form-item>
              <el-form-item label="小助手名称：" prop="ko_qrcode3_title">
                <el-input v-model="form_data.ko_qrcode3_title" placeholder="请输入小助手名称"></el-input>
              </el-form-item>
              <el-form-item label="新浪微博名称：" prop="ko_qrcode4_title">
                <el-input v-model="form_data.ko_qrcode4_title" placeholder="请输入新浪微博名称"></el-input>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
          <el-form-item class="mar_T_50">
            <el-button type="primary" @click="save()">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import UploadOne from "../../components/upload/UploadOne";
export default {
  components: {
    UploadOne,
  },
  data() {
    return {
      activeName: "first",
      loading: true,
      form_data: {
        zh_title: "",
        zh_keywords: "",
        zh_description: "",
        zh_dd_address: "",
        zh_dd_title: "",
        zh_dx_address: "",
        zh_dx_title: "",
        zh_copyright: "",
        zh_qrcode1_title: "",
        zh_qrcode2_title: "",
        zh_qrcode3_title: "",
        zh_qrcode4_title: "",
        zh_qrcode5_title: "",
        zh_traffic: "",
        zh_bus: "",
        dx_email: "",
        dd_email: "",
        qrcode1: "",
        qrcode2: "",
        qrcode3: "",
        qrcode4: "",
        qrcode5: "",
        phone: "",
        mobile: "",
        icp: "",
        copyright: "",
        en_qrcode1_title: "",
        en_qrcode2_title: "",
        en_qrcode3_title: "",
        en_qrcode4_title: "",
        en_qrcode5_title: "",
        en_title: "",
        en_keywords: "",
        en_description: "",
        en_dd_address: "",
        en_dd_title: "",
        en_dx_address: "",
        en_dx_title: "",
        en_copyright: "",
        en_traffic: "",
        en_bus: "",
        id: 0,
        ja_qrcode1_title: "",
        ja_qrcode2_title: "",
        ja_qrcode3_title: "",
        ja_qrcode4_title: "",
        ja_qrcode5_title: "",
        ja_title: "",
        ja_keywords: "",
        ja_description: "",
        ja_dd_address: "",
        ja_dd_title: "",
        ja_dx_address: "",
        ja_dx_title: "",
        ja_copyright: "",
        ja_traffic: "",
        ja_bus: "",
        ko_qrcode1_title: "",
        ko_qrcode2_title: "",
        ko_qrcode3_title: "",
        ko_qrcode4_title: "",
        ko_qrcode5_title: "",
        ko_title: "",
        ko_keywords: "",
        ko_description: "",
        ko_dd_address: "",
        ko_dd_title: "",
        ko_dx_address: "",
        ko_dx_title: "",
        ko_copyright: "",
        ko_traffic: "",
        ko_bus: "",
      },
      id: "",
      rules: {
        zh_title: [
          { required: true, message: "请输入站点标题", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    var that = this;
    that.getDetail();
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios.post("/Config/site").then((res) => {
        if (res) {
          if (res.data) {
            that.form_data = res.data;
          }
          that.loading = false;
        }
      });
    },
    save() {
      const that = this;
      that.$refs.form_data.validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.form_data;
        var url = "/Config/siteupdate";
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.$router.push("/Config/site");
        });
      });
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>